<template>
  <global-dialog-card
    v-model="model"
    :title="payment ? payment.document : $t('finance_payment_fallback_title')"
    hide-actions
    max-width="440"
  >
    <div v-if="payment">
      <p class="detail-amount">{{ formatCurrency(payment.amount) }}</p>

      <div class="detail-rows">
        <div class="detail-row">
          <span>IBAN</span>
          <strong class="mono">{{ payment.iban }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_model_label") }}</span>
          <strong class="mono">{{ payment.model }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_reference_number") }}</span>
          <strong class="mono">{{ payment.referenceNumber }}</strong>
        </div>
      </div>

      <div class="qr-row">
        <div class="qr-box">
          <v-icon size="40">mdi-qrcode</v-icon>
        </div>
        <span class="qr-label">{{ $t("finance_qr_payment_label") }}</span>
      </div>

      <div class="actions-col">
        <primary-button
          v-if="payment.status !== 'paid'"
          block
          :loading="saving"
          @click="$emit('confirm-payment', payment)"
        >
          <v-icon left>mdi-check-circle-outline</v-icon>
          {{ $t("finance_confirm_payment") }}
        </primary-button>
        <v-btn block outlined @click="uploadProof">
          <v-icon left>mdi-paperclip</v-icon>
          {{ $t("finance_upload_proof") }}
        </v-btn>
        <input ref="fileInput" type="file" class="hidden-input" @change="onFileSelected" />
      </div>

      <v-divider class="my-4" />

      <p class="section-label">{{ $t("finance_if_bank_linked") }}</p>
      <v-btn block text disabled>
        <v-icon left>mdi-bank-transfer</v-icon>
        {{ $t("finance_pay_now") }}
      </v-btn>
      <p class="bank-hint">
        {{ $t("finance_bank_not_linked_prefix") }}
        <a href="#" class="bank-link" @click.prevent="$emit('link-bank')">{{ $t("finance_link_account") }}</a>
        {{ $t("finance_bank_link_suffix") }}
      </p>
    </div>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import GlobalDialogCard from "@/components/global/GlobalDialogCard.vue";

export default {
  name: "PlatformPaymentDetailDialog",

  components: { GlobalDialogCard },

  mixins: [hasModel],

  props: {
    payment: {
      type: Object,
      default: null,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    formatCurrency(amount) {
      const value = Number(amount) || 0;
      return `${value.toFixed(2)} ${this.restaurantCurrency}`;
    },

    uploadProof() {
      this.$refs.fileInput?.click();
    },

    onFileSelected(event) {
      const file = event.target.files?.[0];
      if (!file) return;
      this.$emit("upload-proof", file);
      event.target.value = "";
    },
  },
};
</script>

<style scoped>
.detail-amount {
  margin: 0 0 16px;
  font-size: 1.4rem;
  font-weight: 800;
}

.detail-rows {
  display: grid;
  gap: 8px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  font-size: 0.88rem;
  color: rgba(0, 0, 0, 0.6);
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.87);
}

.qr-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
}

.qr-box {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: #f2f3f7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-label {
  font-size: 0.82rem;
  color: rgba(0, 0, 0, 0.6);
}

.actions-col {
  display: grid;
  gap: 8px;
}

.hidden-input {
  display: none;
}

.section-label {
  margin: 0 0 6px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(0, 0, 0, 0.5);
}

.bank-hint {
  margin: 8px 0 0;
  font-size: 0.78rem;
  color: rgba(0, 0, 0, 0.5);
}

.bank-link {
  font-weight: 600;
}
</style>
